export default "https://cdn-web.disco.co/dashboard-layout-2-column-40b1c546dedfe9535272be61c3410339.png";